import type { Ref } from 'vue'
import { onUnmounted, ref } from 'vue'
import { api } from '@/api'
import { CHAPTER_LOCK, CHARGE_TYPE } from '@/constants'
import { useUserStore } from '@/stores'

/**
 * 阅读埋点上报 Composable
 * 负责章节阅读相关的埋点上报
 */

interface ChapterTrackingOptions {
  contentId: Ref<string>
  chapterId: Ref<string>
  book: Ref<any>
  chapter: Ref<any>
  bookRead: (data: any) => void
}

export function useChapterTracking(options: ChapterTrackingOptions) {
  const {
    contentId,
    chapterId,
    book,
    chapter,
    bookRead,
  } = options

  const userStore = useUserStore()
  const startReadTime = ref(new Date().getTime())

  /**
   * 阅读埋点上报
   */
  function handleReadTrack() {
    if (!book.value || !chapter.value)
      return

    // 锁定章节不上报
    if (chapter.value?.lockStatus === CHAPTER_LOCK.LOCK)
      return

    bookRead({
      book_id: book.value.id,
      book_name: book.value.contentName,
      author: book.value?.authorInfo?.author,
      chapter_id: chapterId.value,
      chapter_versionid: chapter.value?.chapterVersionId,
      chapter_name: chapter.value?.contentChapterName,
      is_chargeable: chapter.value.feeType,
      serial_status: book.value.finishStatus === 0 ? 'ongoing' : 'completed',
      chapter_price: chapter.value.chargeType === CHARGE_TYPE.CHAPTER ? chapter.value?.priceAmount : 0,
      currency_coins: userStore.$state.coinBalance,
    })

    startReadTime.value = new Date().getTime()
  }

  /**
   * 用户激活上报
   */
  async function attributionTrack() {
    if (localStorage.getItem('IsActive'))
      return

    try {
      const res = await api.get<any, any>('/member/active')
      if (res.code === 0)
        localStorage.setItem('IsActive', '1')
    }
    catch (error: any) {
      // 静默失败
    }
  }

  /**
   * 页面关闭时的处理
   */
  function handleCloseEvent() {
    handleReadTrack()
    return true
  }

  // 组件卸载时上报
  onUnmounted(() => {
    handleReadTrack()
  })

  return {
    startReadTime,
    handleReadTrack,
    attributionTrack,
    handleCloseEvent,
  }
}
